module.exports = __webpack_public_path__ + "img/Indicatordata-unchecked.fb0fe6f0.svg";